import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../Translations';
import CopyRow from '../../CopyRow';
import { ConnectionResource } from '../../Types';

interface Props {
  resource: ConnectionResource;
}

// The values the client entered in their IdP application during setup, kept
// available so they can review or rebuild the application later.
const SpDetailsCard: React.FC<Props> = ({ resource }) => (
  <div>
    <h3 className="text-base font-semibold text-foreground">
      <T kind="Service provider details" />
    </h3>
    <div className="mt-3 rounded-lg border border-border bg-card p-6">
      <p className="text-sm text-muted-foreground">
        <T kind="The values configured in your identity provider application for this connection." />
      </p>
      <div className="mt-4 rounded-lg border border-border">
        <CopyRow
          label="Identifier"
          hint={<T kind="Entity ID / Audience URI" />}
          value={resource.payload.spDetails.entityId}
          monospaced={true}
        />
        <CopyRow
          label="Reply URL"
          hint={<T kind="Assertion Consumer Service" />}
          value={resource.payload.spDetails.acsUrl}
          monospaced={true}
        />
        <CopyRow
          label="Relay state"
          hint={<T kind="Required for IdP-initiated sign-in - identifies your organization" />}
          value={resource.payload.spDetails.relayState}
          monospaced={true}
        />
      </div>
    </div>
  </div>
);

export default observer(SpDetailsCard);
